<ion-modal #modal
    class="demooz_modal" 
    [class.height_auto]="this.heightAuto"
    [class.small]="this.size === 'small'"
    [class.medium]="this.size === 'medium'"
    [class.big]="this.size === 'big'"
    [class.full]="this.size === 'full'"
    [canDismiss]="this.canDismissMediaModal.bind(this)"
    (didDismiss)="this.onDidDismissMediaModal($event)"       
    >
    <ng-template> 
        <div class="demooz_modal_content">
            <div class="btn_close_modal">
                <ion-icon name="close-outline" (click)="this.dismiss()"></ion-icon>
            </div>
            <div class="demooz_modal_header">
                <ng-content select="[modal_header]"></ng-content>
            </div>
            <div class="demooz_modal_body">
                <ng-content></ng-content>
            </div>
        </div>       
    </ng-template>
</ion-modal>
            